import React from 'react';

export default function Footer({ onNav }) {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo-wrap">
              <div className="footer-logo-icon">🎓</div>
              <div className="footer-logo-text">
                <h3>BASAVESHWAR <span>Pre-Primary</span></h3>
                <p>Belur – Chikkanasabi</p>
              </div>
            </div>
            <p>A safe, joyful and inspiring environment where every child learns, grows and shines since 2013.</p>
          </div>
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              {[['home','Home'],['about','About Us'],['admissions','Admissions'],['academics','Academics'],['facilities','Facilities']].map(([id,l]) => (
                <li key={id} onClick={() => onNav(id)}>{l}</li>
              ))}
            </ul>
          </div>
          <div className="footer-col">
            <h4>Programs</h4>
            <ul>
              {['Nursery','Lower KG (LKG)','Upper KG (UKG)','Play-Based Learning','Creative Arts'].map(p => <li key={p}>{p}</li>)}
            </ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li>📞 +91 8553852843</li>
              <li>📞 +91 9535487630</li>
              <li>✉️ info@basaveshwarpsch.in</li>
              <li>📍 Belur – Chikkanasabi</li>
              <li>🕒 Mon–Fri: 9aM – 5PM</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2024 Basaveshwar Pre-Primary School. All rights reserved.</p>
          <p>Made with ❤️ for every child's bright future</p>
        </div>
      </div>
    </footer>
  );
}
